import { render, staticRenderFns } from "./DocumentPreviewPopup.vue?vue&type=template&id=216f574e&"
import script from "./DocumentPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports